import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { MdCheckCircle, MdCancel } from 'react-icons/md';

interface DemandRow {
    industry: string;
    subIndustry: string;
    hasOpenDemand: boolean;
}

const IndustryDemand = () => {
    const [rows, setRows] = useState<DemandRow[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get(`${CONFIG.apiUrl}/industry/open-demand`)
            .then((res) => setRows(res.data ?? []))
            .catch(() => setRows([]))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="flex flex-col gap-6">
            <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
                <p className="font-geist text-xs font-semibold uppercase tracking-widest text-leadrs-text-soft">
                    Demande du marché
                </p>
                <h1 className="mt-1 font-crimson text-3xl font-semibold text-leadrs-text">
                    Secteurs recherchés par les acheteurs
                </h1>
                <p className="mt-2 font-geist text-sm text-leadrs-text-soft">
                    Pour chaque secteur / sous-secteur, indique si au moins une offre ou un ordre d'achat est
                    actuellement ouvert et recherche des leads.
                </p>
            </div>

            <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
                {loading ? (
                    <p className="font-geist text-sm text-leadrs-text-soft">Chargement...</p>
                ) : rows.length === 0 ? (
                    <p className="font-geist text-sm text-leadrs-text-soft">Aucune donnée disponible.</p>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-left font-geist text-sm">
                            <thead>
                                <tr className="border-b border-leadrs-stroke">
                                    <th className="py-2 pr-4 font-medium text-leadrs-text-soft">Secteur</th>
                                    <th className="py-2 pr-4 font-medium text-leadrs-text-soft">Sous-secteur</th>
                                    <th className="py-2 pr-4 font-medium text-leadrs-text-soft">Demande ouverte</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, i) => (
                                    <tr
                                        key={`${row.industry}-${row.subIndustry}-${i}`}
                                        className="border-t border-leadrs-stroke hover:bg-leadrs-bg"
                                    >
                                        <td className="py-3 pr-4 text-leadrs-text">{row.industry}</td>
                                        <td className="py-3 pr-4 text-leadrs-text-soft">{row.subIndustry}</td>
                                        <td className="py-3 pr-4">
                                            {row.hasOpenDemand ? (
                                                <span className="inline-flex items-center gap-1.5 font-semibold text-leadrs-green-focus">
                                                    <MdCheckCircle className="h-4 w-4" />
                                                    Oui
                                                </span>
                                            ) : (
                                                <span className="inline-flex items-center gap-1.5 text-leadrs-text-soft">
                                                    <MdCancel className="h-4 w-4" />
                                                    Non
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default IndustryDemand;
